"use strict";

/* ================================
   CONFIG
================================ */
const STORAGE_KEY = "glozin__wishlist-items";
const wishlistPage = document.querySelector(".wishlist-page-section");
const wishlistMain = document.querySelector(".wishlist-page-main");

/* ================================
   HELPERS
================================ */
function getWishlistItems() {
  return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
}

function setWishlistItems(items) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
}

function showEmptyState() {
  document
    .querySelector(".wishlist-no-product-js")
    ?.classList.remove("hidden");
}

function removeSkeleton(delay = 0) {
  setTimeout(() => {
    document.querySelector("skeleton-page")?.remove();
    document
      .querySelector(".wishlist-page-section-inner")
      ?.classList.remove("hidden");
  }, delay);
}

/* ================================
   LOAD WISHLIST PRODUCTS
================================ */
function loadWishlistProducts() {
  if (!wishlistMain) return;

  const wishlistItems = getWishlistItems();
  const emptyBlock = wishlistMain.querySelector(".wishlist-no-product-js");

  if (!wishlistItems.length) {
    removeSkeleton(0);
    emptyBlock?.classList.remove("hidden");
    return;
  }

  let query = wishlistItems.map((id) => `id:${id}`).join(" OR ");
  const sectionId = wishlistPage.dataset.sectionId;

  const url =
    `${window.routes.search_url}` +
    `?section_id=${sectionId}` +
    `&type=product&options[unavailable_products]=last` +
    `&q=${encodeURIComponent(query)}`;

  fetch(url)
    .then((res) => res.text())
    .then((htmlText) => {
      const parser = new DOMParser();
      const html = parser.parseFromString(htmlText, "text/html");

      const newContent = html.querySelector(".wishlist-page-main");
      if (!newContent) throw "Wishlist HTML not found";

      wishlistMain.innerHTML = newContent.innerHTML;
      removeSkeleton(600);
    })
    .catch((err) => {
      console.error("Wishlist load error:", err);
      removeSkeleton(0);
      emptyBlock?.classList.remove("hidden");
    });
}

/* ================================
   REMOVE FROM WISHLIST (FIX)
================================ */
document.addEventListener("click", function (e) {
  const btn = e.target.closest("button-wishlist");
  if (!btn) return;

  if (!wishlistPage) return; // only wishlist page

  const productId = btn.dataset.productId;
  const productCard = btn.closest(".wishlist-list");

  if (!productId || !productCard) return;

  // Update storage
  let items = getWishlistItems().filter((id) => id !== productId);
  setWishlistItems(items);

  // Remove from DOM (smooth)
  productCard.style.transition = "opacity .3s ease";
  productCard.style.opacity = "0";

  setTimeout(() => {
    productCard.remove();

    if (!document.querySelector(".wishlist-list")) {
      showEmptyState();
    }
  }, 300);
});

/* ================================
   INIT
================================ */
(function initWishlistPage() {
  if (!wishlistPage) return;

  // Avoid reload on pagination clicks
  if (window.location.search.includes("page=")) return;

  loadWishlistProducts();
})();
